import { Box, Typography } from '@mui/material';

import { PieceAction } from '@apiContract';
import { DialogConfirmation } from '@uiKit/DialogConfirmation';

import { showApiErrorToast } from '@utils/apiErrorToast';

import { useFinishPieceMutation } from '../../hooks/useFinishPieceMutation';
import { ActionComponentProps } from '../../index';
import NotifyMairoomComment from './NotifyComment';
import useNotifyComment from './NotifyComment/useNotifyComment';

export const MarkPickedUp = ({ mailpieces, actionStarted, onActionFinish, isForce }: ActionComponentProps) => {
  const { runAction, isLoading } = useFinishPieceMutation();

  const { values, changeValues } = useNotifyComment();

  const confirmAction = async () => {
    try {
      await runAction({
        action: PieceAction.FinishPickupMailbox,
        pieces: mailpieces,
        comment: values.comment,
        notifyMailroom: values.notifyMailroom,
        additionalData: { isForce },
      });

      onActionFinish();
    } catch (error) {
      showApiErrorToast(error);
    }
  };

  const content = (
    <Box>
      {mailpieces.length === 1 ? (
        <Typography variant="body1" color="text.secondary">
          Are you sure you would like to mark this item as picked up?
        </Typography>
      ) : (
        <Typography variant="body1" color="text.secondary">
          Are you sure you would like to mark this <strong>{mailpieces.length}</strong> items as picked up?
        </Typography>
      )}
      {isForce && <NotifyMairoomComment values={values} onChange={changeValues} withSkipNotifyRecipient={false} />}
    </Box>
  );

  return (
    <DialogConfirmation
      open={actionStarted}
      loading={isLoading}
      maxWidth="sm"
      title={mailpieces.length === 1 ? 'Mark item as picked up' : 'Mark selected items as picked up'}
      content={content}
      acceptButtonHandleClick={confirmAction}
      cancelButtonHandleClick={onActionFinish}
      acceptButtonTitle="Mark as Picked Up"
      cancelButtonTitle="Cancel"
    />
  );
};
